// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StylesGuideP {
  font-size: 14px;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/StylesGuide/Titles/P/P.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,gBAAA;AACJ","sourcesContent":[".StylesGuideP {\n    font-size: 14px;\n    font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
